import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import help from './help'

// 图片转换格式的方法 直接使用就好  不需要知道为什么
function dataURLToBlob(dataurl) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

/* 保存图片的方法（即按钮点击触发的方法）
    第一个参数为需要保存的div的id名
    第二个参数为保存图片的名称 */
function saveImage(dom, scale = 2, imgText = '测试') {
  let a = document.createElement('a')
  return html2canvas(dom, {
    logging: false,
    scale
  }).then(canvas => {
    let dom = document.body.appendChild(canvas)
    dom.style.display = 'none'
    a.style.display = 'none'
    document.body.removeChild(dom)
    let blob = dataURLToBlob(dom.toDataURL('image/png'))
    // console.log(dom.toDataURL('image/png'))
    // console.log(URL.createObjectURL(blob))
    a.setAttribute('href', URL.createObjectURL(blob))
    // 这块是保存图片操作  可以设置保存的图片的信息
    a.setAttribute('download', imgText + '.png')
    document.body.appendChild(a)
    a.click()
    URL.revokeObjectURL(blob)
    document.body.removeChild(a)
  })
}

function savePDF(el, scale = 2, name = '测试', download = true) {
  return html2canvas(el, {
    logging: false,
    scale: scale || 2
  }).then(canvas => {
    const pdf = new jsPDF('p', 'mm', 'a4', true)
    let ctx = canvas.getContext('2d'),
      a4w = 210,
      a4h = 297, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
      imgHeight = Math.floor((a4h * canvas.width) / a4w), //按A4显示比例换算一页图像的像素高度
      renderedHeight = 0

    while (renderedHeight < canvas.height) {
      let page = document.createElement('canvas')
      page.width = canvas.width
      page.height = Math.min(imgHeight, canvas.height - renderedHeight) //可能内容不足一页

      //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
      page
        .getContext('2d')
        .putImageData(
          ctx.getImageData(
            0,
            renderedHeight,
            canvas.width,
            Math.min(imgHeight, canvas.height - renderedHeight)
          ),
          0,
          0
        )
      pdf.addImage(
        page.toDataURL('image/jpeg', 1.0),
        'JPEG',
        0,
        0,
        a4w,
        Math.min(a4h, (a4w * page.height) / page.width),
        '',
        'FAST'
      ) //添加图像到页面，保留10mm边距

      // 添加超链接
      const hrefs = document.getElementsByTagName('a')
      for (let item of hrefs) {
        const t = parseInt(
          ((help.getElementTop(item) - help.getElementTop(el)) * 210) /
            el.offsetWidth
        )
        const l = parseInt(
          ((help.getElementLeft(item) - help.getElementLeft(el)) * 210) /
            el.offsetWidth
        )
        const w = parseInt((item.offsetWidth * 210) / el.offsetWidth) + 2
        pdf.link(l, t, w, 6, { url: item.getAttribute('href') })
      }
      renderedHeight += imgHeight
      if (renderedHeight < canvas.height) pdf.addPage() //如果后面还有内容，添加一个空页
      page = ''
    }

    if (download) {
      pdf.save(name + '.pdf')
    } else {
      const blob = pdf.output('blob')
      let files = new File([blob], name, { type: 'application/pdf' })
      return files
    }
  })
}

export { saveImage, savePDF }
